import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Loader from '../../Global/Loader';
// import { navigate } from '@reach/router';
import { useNavigate } from 'react-router-dom';
function Modal2Booked({ isOpen, onClose, consultation, consultant, fetchConsultations }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    consultationId: '',
    studentName: '',
    email: '',
    consultationDate: '',
    consultationTime: '',
    consultantId: '',
    meetingLink: '',
    isConducted: null,
    status: '',
    consultantReview: '',
  });

  // console.log(consultation);


  // Update the useEffect
  useEffect(() => {
    if (consultation) {
      setFormData({
        ...formData,
        consultationId: consultation.consultationId || '',
        studentName: consultation.studentName || '',
        email: consultation.email || '',
        consultationTime: consultation.consultationTime || '',
        consultationDate: consultation.consultationDate || '',
        consultantId: consultation.consultantId || '',
        meetingLink: consultation.meetingLink || '',
        status: consultation.status || '',
        isConducted: consultation.isConducted || false,
        consultantReview: consultation.consultantReview || '',
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const isFormComplete = () => {
    return Object.values(formData).every(value => value !== '');
  };
  ;

  // Remove handleBook function and update handleMarkAsConducted
  const handleMarkAsConducted = async (e) => {
    e.preventDefault();
    if (!formData.consultantReview) {
      alert('Please add a review before submitting');
      return;
    }

    setLoading(true);
    try {
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/consultation/${consultation._id}/update`,
        {
          isConducted: true,
          consultantReview: formData.consultantReview,

        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        }
      );
      setIsSubmitted(true);
      fetchConsultations();
      handleClose();
    } catch (error) {
      // console.error('Error updating consultation:', error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      consultationId: '',
      studentName: '',
      email: '',
      consultationTime: '',
      consultationDate: '',
      consultantId: '',
      meetingLink: ''
    });
    setLoading(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      {loading && <Loader />}
      {
        isSubmitted && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Success!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                Your application has been submitted successfully.
              </h4>
              <div className="flex justify-end space-x-4">
                {/* Proceed Button */}
                <button
                  onClick={() => setIsSubmitted(null)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }

      {
        error && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white w-full max-w-md mx-auto rounded-lg shadow-lg p-6">
              {/* Modal Content */}
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Something went wrong!
              </h2>
              <h4 className="text-sm text-gray-600 mb-6">
                We encountered an issue while processing your request. Please try again later. If the problem persists, contact support.
              </h4>
              <div className="flex justify-end space-x-4">
                {/* Proceed Button */}
                <button
                  onClick={() => setError(null)}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none"
                >
                  Okay
                </button>
              </div>
            </div>
          </div>
        )
      }

      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] flex flex-col">
          {/* Header */}
          <div className="p-6 border-b">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-semibold">Consultation Details</h2>
              <button
                onClick={handleClose}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>

          {/* Content - Scrollable */}
          <div className="p-6 overflow-y-auto">
            <form id="consultationForm" onSubmit={(e) => e.preventDefault()}>
              {/* Non-editable Information Section */}
              <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h3 className="text-lg font-medium mb-4">Basic Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Consultation ID</label>
                    <p className="mt-1 text-sm text-gray-900">{formData.consultationId}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Student Name</label>
                    <p className="mt-1 text-sm text-gray-900">{formData.studentName}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Email</label>
                    <p className="mt-1 text-sm text-gray-900">{formData.email}</p>
                  </div>
                </div>
              </div>

              {/* Editable Information Section */}
              <div className="bg-white border rounded-lg p-4">
                <h3 className="text-lg font-medium mb-4">Consultation Details</h3>
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Date</label>
                      <p className="mt-1 text-sm text-gray-900">
                        {new Date(formData.consultationDate).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        })}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Time</label>
                      <p className="mt-1 text-sm text-gray-900">
                        {new Date(`1970-01-01T${formData.consultationTime}`).toLocaleTimeString('en-US', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true,
                        })}
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">Consultant</label>
                    <p className="mt-1 text-sm text-gray-900">{consultation?.consultantName}</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">Meeting Link</label>
                    <a
                      href={formData.meetingLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-1 text-sm text-blue-600 hover:text-blue-800"
                    >
                      {formData.meetingLink}
                    </a>
                  </div>

                  {/* Only editable field */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Consultant Review <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="consultantReview"
                      value={formData.consultantReview}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[150px] resize-y"
                      placeholder="Enter your review here..."
                      required
                      readOnly={(consultation.isConducted)}
                    />
                  </div>
                </div>
              </div>

            </form>
          </div>

          {/* Footer */}
          <div className="p-6 border-t mt-auto">
            <div className="flex justify-end space-x-4">
              <button
                type="button"
                onClick={handleClose}
                className="px-4 py-2 text-gray-700 bg-white border border-gray-700 rounded hover:bg-gray-700 hover:text-white"
              >
                Cancel
              </button>
              {!consultation.isConducted && <button
                type="button"
                onClick={handleMarkAsConducted}
                disabled={loading || !formData.consultantReview}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
              >
                Mark as Conducted
              </button>}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
export default Modal2Booked;